import { locales } from '@americanexpress/conditional-features';
import { getActiveLocaleSelector } from '@americanexpress/travel-selectors';
import { getTravelHomeApiUrl, getApigeeApiUrl } from '../selectors/selectors';

export default {
  fetch: (id, action, state) => {
    if (getActiveLocaleSelector(state) !== locales.EN_US) {
      return {
        url: `${getApigeeApiUrl(state)}/travel/v2/travel_services/traveler/details`,
        opts: {
          method: 'GET',
          timeout: 30e3,
          credentials: 'include',
          headers: {
            'Content-Type': 'application/json',
          },
        },
      };
    }

    return {
      url: `${getTravelHomeApiUrl(state)}/travel/home/v1/traveler`,
      opts: {
        method: 'GET',
        credentials: 'include',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
          client_id: '684C957199C3BE6C153A778D1986032B',
        },
      },
    };
  },
};
